import SliderRoom from './SliderRoom';

export default SliderRoom;
